import React, { useEffect } from 'react';
import { Screen } from '@/components/layout/Screen';
import { USSDSimulator } from '@/features/ussd/USSDSimulator';
import { USSDMenuBuilder } from '@/features/ussd/USSDMenuBuilder';
import { useUSSDState } from '@/features/ussd/ussdState';
import { createMainMenu } from '@/features/ussd/screens';
import { Button } from '@/components/ui/button';
import { Smartphone, Info } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const USSDScreen: React.FC = () => {
  const { session, startSession, endSession } = useUSSDState();
  const mainMenu = createMainMenu();

  const handleStartSession = () => {
    startSession(mainMenu);
  };

  return (
    <Screen 
      showTopBar 
      showBottomNav={false}
      topBarProps={{ title: 'USSD Simulator', showBack: true }}
    >
      <div className="space-y-6 p-4 pb-20">
        {/* Info Banner */}
        <Alert>
          <Info className="h-4 w-4" />
          <AlertDescription>
            This simulator replicates the feature phone USSD experience. Use number keys
            to navigate menus (20 chars wide, 6 lines max).
          </AlertDescription>
        </Alert>

        {/* Start Session Button */}
        {!session && (
          <div className="flex justify-center">
            <Button
              onClick={handleStartSession}
              size="lg"
              className="gap-2"
            >
              <Smartphone className="h-5 w-5" />
              Dial *123# to Start
            </Button>
          </div>
        )}

        {/* USSD Simulator */}
        <div className="space-y-4">
          <USSDSimulator onClose={endSession} />
          
          {session && (
            <USSDMenuBuilder menu={mainMenu} />
          )}
        </div>

        {/* Instructions */}
        {session && (
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <h3 className="font-semibold text-sm text-foreground">How to Use:</h3>
            <ul className="text-xs text-muted-foreground space-y-1 list-disc list-inside">
              <li>Type numbers (1-9) to select menu options</li>
              <li>Type 0 to submit input or exit</li>
              <li>Type 00 to go back</li>
              <li>Session expires after 60 seconds</li>
              <li>All submissions sync to main app</li>
            </ul>
          </div>
        )}
      </div>
    </Screen>
  );
};
